import { splitPath } from '@tencent/data-schema-core/lib/utils/path';
export const verifyDataSchemaPath = path => {
  try {
    splitPath(path);
    return true;
  } catch (e) {
    return false;
  }
};
//# sourceMappingURL=verifyDataSchemaPath.js.map
